import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";

export interface OpacityFilterProps {
  value: Array<AutocompleteData> | undefined;
  onChange: Dispatch<Array<AutocompleteData>>;
}

export const ColorTagFilter = ({
  value = [],
  onChange,
}: OpacityFilterProps) => {
  const { t } = useTranslation();
  return (
    <ColorSearchAutocomplete
      checkbox
      type="colorTag"
      onChange={onChange}
      value={value}
      label={t("filter_color_tag")}
    />
  );
};
